/* ================================================================
   MORENOS.STORE — v11 "FORGED" Interactions
   Custom cursor · Scroll reveals · Magnetic cards · Ripple ·
   Urgency · Back-to-top · Header scroll state
   ================================================================ */
(function () {
  'use strict';

  // ── Custom Cursor ──────────────────────────────────────────────
  function initCursor() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.innerWidth < 750) return;

    const cursor = document.createElement('div');
    cursor.id = 'morenos-cursor';
    document.body.appendChild(cursor);

    let cx = -100, cy = -100, tx = -100, ty = -100;

    document.addEventListener('mousemove', e => {
      tx = e.clientX; ty = e.clientY;
      if (!cursor.classList.contains('active')) cursor.classList.add('active');
    });

    document.addEventListener('mousedown', () => cursor.classList.add('click'));
    document.addEventListener('mouseup', () => cursor.classList.remove('click'));

    // Hover detection
    const hoverEls = 'a, button, .card-wrapper, .collection-list__item, input, select, textarea, [role="button"]';
    document.addEventListener('mouseover', e => {
      if (e.target.closest(hoverEls)) cursor.classList.add('hover');
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest(hoverEls)) cursor.classList.remove('hover');
    });

    function animate() {
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      cursor.style.transform = 'translate(' + cx + 'px, ' + cy + 'px) translate(-50%, -50%)';
      requestAnimationFrame(animate);
    }
    animate();
  }

  // ── Scroll Progress ───────────────────────────────────────────
  function initScrollProgress() {
    const bar = document.createElement('div');
    bar.id = 'morenos-scroll-progress';
    document.body.prepend(bar);
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(() => {
          const pct = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
          bar.style.width = Math.min(pct, 100) + '%';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Scroll Reveal — multi-direction ───────────────────────────
  function initScrollReveal() {
    const selectors = [
      '.card-wrapper', '.multicolumn-card', '.collection-list__item',
      '.newsletter', '.image-with-text', '.rich-text',
      '.trust-badges-section'
    ];
    const els = document.querySelectorAll(selectors.join(','));

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const delay = e.target.dataset.revealDelay || 0;
          setTimeout(() => e.target.classList.add('visible'), +delay);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });

    els.forEach((el, i) => {
      // Alternate reveal directions for visual interest
      if (el.matches('.image-with-text')) {
        el.classList.add(i % 2 === 0 ? 'scroll-reveal--left' : 'scroll-reveal--right');
      } else if (el.matches('.newsletter, .rich-text')) {
        el.classList.add('scroll-reveal--scale');
      } else {
        el.classList.add('scroll-reveal');
      }
      obs.observe(el);
    });

    // Stagger grids
    document.querySelectorAll('.product-grid .card-wrapper').forEach((el, i) => {
      el.dataset.revealDelay = (i % 4) * 100;
    });
    document.querySelectorAll('.collection-list .collection-list__item').forEach((el, i) => {
      el.dataset.revealDelay = i * 120;
    });
    document.querySelectorAll('.multicolumn-list .multicolumn-card').forEach((el, i) => {
      el.dataset.revealDelay = i * 150;
    });
  }

  // ── Magnetic Tilt on Cards ─────────────────────────────────────
  function initMagneticCards() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.card-wrapper').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        const rx = (y - 0.5) * 12;
        const ry = (0.5 - x) * 12;
        card.style.transform = 'translateY(-12px) perspective(800px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1), box-shadow 0.5s cubic-bezier(0.16,1,0.3,1)';
        setTimeout(() => card.style.transition = '', 500);
      });
    });
  }

  // ── Header Scroll State ────────────────────────────────────────
  function initHeaderScroll() {
    const header = document.querySelector('.header');
    if (!header) return;
    let lastY = 0;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastY = window.scrollY;
    }, { passive: true });
  }

  // ── Ripple Effect ─────────────────────────────────────────────
  function initRipple() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.button--primary, .product-form__submit, .newsletter-form__button');
      if (!btn) return;
      const r = btn.getBoundingClientRect();
      const s = Math.max(r.width, r.height);
      const rip = document.createElement('span');
      rip.style.cssText = 'position:absolute;width:'+s+'px;height:'+s+'px;border-radius:50%;' +
        'background:rgba(255,255,255,0.18);left:'+(e.clientX-r.left-s/2)+'px;top:'+(e.clientY-r.top-s/2)+'px;' +
        'transform:scale(0);animation:rippleAnim 0.5s ease-out forwards;pointer-events:none';
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(rip);
      setTimeout(() => rip.remove(), 550);
    });
  }

  // ── ATC Feedback ──────────────────────────────────────────────
  function initCartFeedback() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.product-form__submit');
      if (!btn || btn.hasAttribute('disabled')) return;
      setTimeout(() => {
        if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) {
          btn.style.background = '#22c55e';
          btn.style.boxShadow = '0 6px 24px rgba(34,197,94,0.35)';
          setTimeout(() => { btn.style.background = ''; btn.style.boxShadow = ''; }, 1800);
        }
      }, 300);
    });
  }

  // ── Urgency Indicators ────────────────────────────────────────
  function initUrgency() {
    if (!location.pathname.includes('/products/')) return;
    const form = document.querySelector('.product-form, .product__info-container');
    if (!form) return;

    const slug = location.pathname.split('/products/')[1] || '';
    const seed = [...slug].reduce((a, c) => a + c.charCodeAt(0), 0);
    const viewers = 3 + (seed % 12);

    const wrap = document.createElement('div');
    wrap.className = 'morenos-urgency-wrap';

    const vb = document.createElement('div');
    vb.className = 'morenos-badge morenos-badge--viewers';
    vb.innerHTML = '<span class="morenos-badge__dot"></span>' + viewers + ' Personen schauen sich das gerade an';
    wrap.appendChild(vb);

    if ((seed % 10) < 3) {
      const sb = document.createElement('div');
      sb.className = 'morenos-badge morenos-badge--stock';
      sb.innerHTML = '<span class="morenos-badge__dot"></span>Nur noch ' + (3 + seed % 6) + ' auf Lager';
      wrap.prepend(sb);
    }

    const target = form.querySelector('.product-form__buttons, .product-form__submit');
    if (target) target.parentNode.insertBefore(wrap, target);
  }

  // ── Trust Bar (Product Page) ──────────────────────────────────
  function initTrustBar() {
    if (!location.pathname.includes('/products/')) return;
    const desc = document.querySelector('.product__description');
    const container = desc || document.querySelector('.product__info-container');
    if (!container) return;

    const bar = document.createElement('div');
    bar.className = 'morenos-trust-bar';
    bar.innerHTML = '<span>✦ Handgefertigt</span><span>✦ Kostenloser Versand ab 50€</span><span>✦ 30 Tage Rückgabe</span>';
    container.parentNode.insertBefore(bar, container.nextSibling);
  }

  // ── Sticky ATC (Mobile) ───────────────────────────────────────
  function initStickyATC() {
    if (window.innerWidth > 749) return;
    if (!location.pathname.includes('/products/')) return;

    const atcBtn = document.querySelector('.product-form__submit');
    const priceEl = document.querySelector('.price-item--regular, .price-item--sale');
    if (!atcBtn || !priceEl) return;

    const sticky = document.createElement('div');
    sticky.className = 'morenos-sticky-atc';
    const priceSpan = document.createElement('span');
    priceSpan.className = 'morenos-sticky-atc__price';
    priceSpan.textContent = priceEl.textContent.trim();
    const btn = document.createElement('button');
    btn.className = 'morenos-sticky-atc__btn';
    btn.textContent = 'IN DEN WARENKORB';
    btn.addEventListener('click', () => atcBtn.click());
    sticky.appendChild(priceSpan);
    sticky.appendChild(btn);
    document.body.appendChild(sticky);

    const obs = new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-visible', !e.isIntersecting);
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }

  // ── Back to Top ───────────────────────────────────────────────
  function initBackToTop() {
    const btn = document.createElement('button');
    btn.id = 'morenos-back-to-top';
    btn.setAttribute('aria-label', 'Zurück nach oben');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);

    window.addEventListener('scroll', () => {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Init Everything ───────────────────────────────────────────
  function init() {
    initCursor();
    initScrollProgress();
    initScrollReveal();
    initMagneticCards();
    initHeaderScroll();
    initRipple();
    initCartFeedback();
    initUrgency();
    initTrustBar();
    initStickyATC();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();